import fetchAllTransactions from "./fetchAllDonations";

const totalCollection = async () => {
    const transactions = await fetchAllTransactions()
    let totalAmount = 0;

    transactions.map((transaction, i)=>{
        totalAmount += transaction.amount
    })

    return totalAmount
}
export default totalCollection